import { createContext, FC, PropsWithChildren } from 'react';
import { ScoreContextInterface } from './Contexts.model';

export const ScoreContext = createContext<ScoreContextInterface>({});

export const ScoreProvider: FC<PropsWithChildren> = ({ children }) => {
	return <ScoreContext.Provider value={{}}>{children}</ScoreContext.Provider>;
};
